const scrollBg = () => {
	const box = document.querySelector(".custom-scroll-bg");
	if (!box) return;

	const headings = box.querySelectorAll(".wp-block-heading");

	headings.forEach((h) => {
		h.style.color = "white";
	});

	const isMobile = window.matchMedia("(max-width: 767px)").matches;
	const duration = isMobile ? 650 : 1500;
	const triggerY = window.innerHeight * (isMobile ? 0.9 : 0.4);

	let state;
	let isAnimating = false;

	const animate = (from, to, nextState) => {
		isAnimating = true;

		const startTime = performance.now();

		const step = (currentTime) => {
			const elapsed = currentTime - startTime;

			let t = Math.min(elapsed / duration, 1);

			const progress = from + (to - from) * t;

			const whiteStart = 60;
			const gradientSize = 40;

			const whiteStop = whiteStart - progress * (whiteStart + gradientSize);
			const blackStop = whiteStop + gradientSize;

			box.style.background = `
                linear-gradient(
                    180deg,
                    white ${whiteStop}%,
                    black ${blackStop}%
                )
            `;

			if (t < 1) {
				requestAnimationFrame(step);
			} else {
				isAnimating = false;
				state = nextState;

				if (state === "black") {
					box.style.background = "black";
				} else {
					box.style.background = `
                        linear-gradient(
                            180deg,
                            white 60%,
                            black 100%
                        )
                    `;
				}
			}
		};

		requestAnimationFrame(step);
	};

	const checkTrigger = () => {
		if (isAnimating) return;

		const rect = box.getBoundingClientRect();

		if (state === "white" && rect.top <= triggerY) {
			animate(0, 1, "black");
		}

		if (state === "black" && rect.top > triggerY) {
			animate(1, 0, "white");
		}
	};

	const rect = box.getBoundingClientRect();

	if (rect.top <= triggerY) {
		state = "black";
		box.style.background = "black";
	} else {
		state = "white";
		box.style.background = `
            linear-gradient(
                180deg,
                white 60%,
                black 100%
            )
        `;
	}

	window.addEventListener("scroll", checkTrigger);
	window.addEventListener("resize", checkTrigger);

	checkTrigger();
};

export { scrollBg };
